<template>
  <v-container fluid class="px-6 py-6">
    <v-row>
      <v-col lg="12">
        <h3 class="text-h5 font-weight-bold mb-4">Company Information</h3>
        <!-- <div>
          {{ currentUser.companyId }}
        </div> -->
        <v-card v-if="company" class="pa-4">
          <v-row>
            <v-col cols="12" md="12">
              <label class="text-xs text-typo font-weight-bolder ms-1"
                >Company Name</label
              >
              <v-text-field
                v-model="company.name"
                outlined
                dense
                disabled
                prepend-inner-icon="mdi-office-building"
                class="
                  font-size-input
                  placeholder-lighter
                  text-light-input
                  border border-radius-md
                  mt-2
                "
                hide-details="auto"
                width="100%"
              ></v-text-field>
            </v-col>
          </v-row>
          <hr class="my-4" style="background-color: #f8f8f8;" />
          <v-row class="mt-4">
            <v-col cols="12">
              <div class="d-flex justify-space-between align-center mb-2">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Company Users</label
                >
                <v-btn
                  color="primary"
                  small
                  dark
                  @click="dialog = true"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Invite User
                </v-btn>
              </div>
              <v-list v-if="company && company.users && company.users.length">
                <v-list-item v-for="userId in company.users" :key="userId">
                  <v-list-item-content>
                    <v-list-item-title v-if="userId === $store.state.auth.uid">{{
                      userNames[userId]
                    }} (You)</v-list-item-title>
                    <v-list-item-title v-else>{{
                      userNames[userId] || "Loading..."
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-else class="text-center pa-4">
                <p class="text-subtitle-1">No users found</p>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card v-else class="pa-4">
          <v-row>
            <v-col cols="12" class="text-center">
              <p class="text-h6">Loading company information...</p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Invite User Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          Invite Users
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <InviteUser 
            ref="inviteUserForm" 
            :company-id="currentUser.companyId"
            @send-invites="handleInvite" 
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { fetchSingleObjectByKey } from "@/services/firebase-helpers";
import InviteUser from "@/components/InviteUser.vue";

export default {
  name: "Company",
  components: {
    InviteUser
  },
  data() {
    return {
      loading: true,
      userNames: {},
      dialog: false,
    };
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
    currentUser() {
      return this.$store.state.auth;
    },
  },
  methods: {
    async fetchUserNames() {
      if (!this.company || !this.company.users) return;

      const promises = this.company.users.map(async (userId) => {
        try {
          const user = await fetchSingleObjectByKey("users", userId);
          if (user) {
            this.$set(
              this.userNames,
              userId,
              `${user.firstName || ""} ${user.lastName || ""}`.trim() || userId
            );
          } else {
            this.$set(this.userNames, userId, userId);
          }
        } catch (error) {
          console.error("Error fetching user:", error);
          this.$set(this.userNames, userId, userId);
        }
      });

      await Promise.all(promises);
    },
    handleInvite() {
      const emails = this.$refs.inviteUserForm.getEmails();
      // TODO: Implement invite logic
      console.log('Inviting users:', emails);
      this.dialog = false;
    },
  },
  async created() {
    if (this.company) {
      await this.fetchUserNames();
    }
    this.loading = false;
  },
  watch: {
    company: {
      async handler(newCompany) {
        if (newCompany) {
          await this.fetchUserNames();
        }
      },
      immediate: true,
    },
  },
};
</script>
